import { gsap } from 'gsap';
window.menuNav = new(function() {
    this.timelineMenu = gsap.timeline({paused:true});
    this.init = function() {
        $('[data-inject-nav]').html($('.default-nav-list').html())
        
        this.timelineMenu.fromTo('.main-nav__wrapper',.5,{
            autoAlpha:0,
            xPercent:100,
            ease: 'power2.inOut',

        },{
            autoAlpha:1,
            xPercent:0,

            ease: 'power2.inOut',
        },'triggerMenuBG')
        this.timelineMenu.from('.main-nav__wrapper a.links', .6 ,{
            fontWeight: 100,
            ease: 'power2.inOut',
            stagger: .03,

        },'triggerMenuBG');
        
        
        

        $('header .main-nav__wrapper a').on('click', function (e) {
            if($(this).hasClass('current'))
            {
                $('.main-header .btn-menu').trigger('click');
                e.preventDefault();
                return false;
            }
        });
        
        
        $('body').on('click','[data-lang-redirection] a',function(e){
            e.preventDefault()
            e.stopPropagation()
            let controller = $('[data-barba-controller]').attr('data-barba-controller');
            let action = $('[data-barba-controller]').attr('data-barba-action')
            let url = $(this).attr('href') + '/app-redirection?controller='+controller+'&action='+action;
            if ($('[data-barba-details-repository]').length && $('[data-barba-details-id]').length){
                let routeDetails = $('[data-barba-details-repository]').attr('data-barba-details-repository')
                let id = $('[data-barba-details-id]').attr('data-barba-details-id')

                url += '&module='+routeDetails+'&id='+ id;
            }
            window.barba.instance.force(url);
        })


        $('.btn-menu').on('click', function(e) {
            e.preventDefault();
            if ($("body").hasClass('open-menu')){
                window.menuNav.hide();
                console.log('HELLO')
            } else {
                window.menuNav.show();
                $("body,html").addClass('open-menu');
            }
        })
        $('header .main-nav__wrapper').find('a.links.current').on('click',function(){
            $('.btn-menu').trigger('click');
        })
    }
    
    this.show = function(){
        
        this.timelineMenu.play()
        $('body,html').addClass('open-menu')
        

    }
    this.hide = function(){


    return new Promise((resolve)=>{
        if ($('body').hasClass('open-menu') != true){
            resolve(true);
            return;
        }
        else{
           
            this.timelineMenu.reverse();
            this.timelineMenu.eventCallback('onReverseComplete',()=>{
                resolve(true);
                $('body,html').removeClass('open-menu')

            })
        }

       

       
    });





    }

    this.reset = function(){

        $('body,html').removeClass('open-menu');
        this.timelineMenu.progress(0);
        this.timelineMenu.paused(true);


    }
    this.updateCurrentLink = function(){

        $('header a.links').removeClass('current');
        $('header a.links').each(function(index){
            let elHref = $(this).prop("href")

            if ( elHref  == document.location.href ){
                $(this).addClass('current');
            }

        })
    }
})
